import http from '../api/http';
import {
  API_DELIVERIES,
  API_DELIVERIES_UNREAD_TOTAL,
  API_MENSAGENS,
} from '../api/apiConfig';
import {
  Message,
  MessageDelivery,
  MessageDeliverySummary,
} from '../types/mensageria';
import { createCrudService } from './crudFactory';

export const mensagensService = createCrudService<Message>(API_MENSAGENS);
export const deliveriesService = createCrudService<MessageDelivery>(API_DELIVERIES);

export const publishMessage = (messageId: number) =>
  http.post(`${API_MENSAGENS}${messageId}/publish/`).then((res) => res.data);

export const markDeliveryRead = (deliveryId: number) =>
  http.post<MessageDelivery>(`${API_DELIVERIES}${deliveryId}/mark_read/`).then((res) => res.data);

export const markDeliveryArchived = (deliveryId: number) =>
  http.post<MessageDelivery>(`${API_DELIVERIES}${deliveryId}/mark_archived/`).then((res) => res.data);

export const markDeliveryRemoved = (deliveryId: number) =>
  http.post<MessageDelivery>(`${API_DELIVERIES}${deliveryId}/mark_removed/`).then((res) => res.data);

export const getDeliveriesUnreadSummary = () =>
  http.get<MessageDeliverySummary>(API_DELIVERIES_UNREAD_TOTAL).then((res) => res.data);
